import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import R from '../../core-res/R';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import DRNText from '../../standard/Text/DRNText';
import DRNImage from '../../standard/Image/DRNImage';
import DRNCardView from '../../standard/Card/DRNCardView';
import { withTheme } from '../../theme';
import { withSmartKey } from '../../smartkey';
const VARIANT_CELL = 'cell';
const VARIANT_CARD = 'card';
class DrillDown extends Component {
    constructor() {
        super(...arguments);
        this._renderCellText = () => {
            const { cellText, description, theme, disabled, accessibilityLabel, testID } = this.props;
            const cellTextColor = disabled ? theme.textMuted : theme.textPrimary;
            const cellTextStyle = Object.assign({}, R.typography.uiBaseline, { color: cellTextColor });
            const descriptionColor = disabled ? theme.textMuted : theme.textSecondary;
            const descriptionStyle = Object.assign({}, R.typography.uiTiny, { color: descriptionColor });
            if (description) {
                return (<View style={styles.cellWithDescription}>
          <DRNText style={cellTextStyle} accessibilityLabel={accessibilityLabel} testID={testID}>
            {cellText}
          </DRNText>
          <DRNText style={descriptionStyle}>{description}</DRNText>
        </View>);
            }
            return (<View style={styles.cellWithoutDescription}>
        <DRNText style={cellTextStyle} accessibilityLabel={accessibilityLabel} testID={testID}>
          {cellText}
        </DRNText>
      </View>);
        };
        this._renderDrillDown = () => {
            const { variant, IconStart, endText, onPress, theme, disabled } = this.props;
            const mainContainerStyle = {
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingHorizontal: R.spacing.m,
            };
            if (variant === VARIANT_CELL) {
                mainContainerStyle.borderBottomWidth = R.border.width.thin;
                mainContainerStyle.borderBottomColor = theme.borderSubtle;
            }
            mainContainerStyle.backgroundColor = disabled ? theme.lightNeutral : theme.lightPrimary;
            const endTextColor = disabled ? theme.textMuted : theme.textSecondary;
            const endTextStyle = Object.assign({}, R.typography.uiBaseline, { color: endTextColor });
            const chevronStyle = {
                width: 24,
                height: 24,
                tintColor: endTextColor,
                transform: [{ rotateZ: '90deg' }],
            };
            return (<DRNTouchableWrapper onPress={onPress} disabled={disabled} accessible={!DRNUtil.isiOS()}>
        <View style={mainContainerStyle}>
          <View style={styles.cellTextContainer}>
            {IconStart && (<View style={styles.iconStart}>
                <IconStart />
              </View>)}
            {this._renderCellText()}
          </View>
          <View style={styles.endContainer}>
            {!!endText && (<View style={styles.endTextContainer}>
                <DRNText style={endTextStyle}>{endText}</DRNText>
              </View>)}
            <DRNImage style={chevronStyle} source={require('../../../images/ic-sys-chevron-up.png')}/>
          </View>
        </View>
      </DRNTouchableWrapper>);
        };
    }
    render() {
        const { variant } = this.props;
        if (variant === VARIANT_CELL) {
            return this._renderDrillDown();
        }
        return <DRNCardView>{this._renderDrillDown()}</DRNCardView>;
    }
}
DrillDown.smartKeyName = ['cellText', 'description'];
DrillDown.VARIANT_CELL = VARIANT_CELL;
DrillDown.VARIANT_CARD = VARIANT_CARD;
DrillDown.defaultProps = {
    variant: VARIANT_CELL,
    disabled: false,
};
const styles = StyleSheet.create({
    cellTextContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    endContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconStart: {
        marginRight: R.spacing.s,
    },
    cellWithDescription: {
        flex: 1,
        paddingVertical: R.spacing.xs,
        flexDirection: 'column',
    },
    cellWithoutDescription: {
        flex: 1,
        paddingVertical: R.spacing.m,
    },
    endTextContainer: {
        marginRight: R.spacing.xs,
    },
});
export default withSmartKey(withTheme(DrillDown));
